// Copyright (c) 2016 Deere & Company

import './accordion.scss';
import React, {PropTypes} from 'react';
import AccordionHeader from './accordion-header';
import AccordionState from '../state/accordion';

function handleClick() {

    this.onAccordionToggle(this.accordion.accordionId);

}

const isOpenClassName = props =>
    props.accordion.isExpanded ? 'is-open' : 'is-closed';

const accordionClassName = props =>
    `accordion ${props.accordion.accordionId} ${isOpenClassName(props)}`;

const Accordion = props =>
    <section className={accordionClassName(props)}>
        <AccordionHeader
            isExpanded={props.accordion.isExpanded}
            onClick={props::handleClick}
            secondaryNode={props.secondaryHeaderNode}
            title={props.title}
        />
        {props.accordion.isExpanded ?
            <div className='accordion-body'>
                {props.body}
            </div> : null
        }
    </section>;

Accordion.displayName = 'Accordion';
Accordion.propTypes = {
    accordion: PropTypes.instanceOf(AccordionState).isRequired,
    body: PropTypes.node.isRequired,
    onAccordionToggle: PropTypes.func.isRequired,
    secondaryHeaderNode: PropTypes.node,
    title: PropTypes.node.isRequired
};

export default Accordion;



// WEBPACK FOOTER //
// ./src/shared/components/smart-accordion/components/accordion.js